import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { state } = useAuth();
  const location = useLocation();

  if (state.status === "unknown") {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm uppercase-track text-[var(--color-kj-text-light)]">
        Loading…
      </div>
    );
  }
  if (state.status === "anonymous") {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
};
